module.exports = __webpack_public_path__ + "static/kantree-419973a5525fea580ac7d26f84446a41.png";